import { getI18n, useTranslation } from "react-i18next";
import source from "./locales/en/applicationMetadata";

export type InstallFieldPresentation = {
  label?: string;
  placeholder?: string;
  helpText?: string;
  section?: string;
  options?: Record<string, string>;
};

export type AlertPresentation = {
  message?: string;
  badgeLabel?: string;
  actionLabel?: string;
  toggle?: { enabledLabel?: string; disabledLabel?: string };
};

export type AppPresentation = {
  description?: string;
  descriptionLong?: string;
  features?: string[];
  category?: string;
  installVersions?: Record<string, string>;
  installConfig?: Record<string, InstallFieldPresentation>;
  installPreview?: { label?: string; description?: string };
  confirmInstall?: { title?: string; body?: string };
  alertConfig?: AlertPresentation;
  configFiles?: Record<string, string>;
};

type MetadataTranslator = {
  t: (key: keyof typeof source, options: {
    ns: "applicationMetadata";
    keySeparator: false;
    defaultValue: string;
    interpolation: { skipOnVariables: true };
  }) => string;
};

/** Only explicit, recognized authored identities may replace supplied text. */
export function applicationMetadataText(code: string | null | undefined, fallback: string): string {
  if (!code || !Object.prototype.hasOwnProperty.call(source, code)) return fallback;
  const engine = getI18n();
  if (!engine?.isInitialized) return fallback;
  const key = code as keyof typeof source;
  // This dynamic boundary is restricted by the own-key allowlist above.
  return (engine as unknown as MetadataTranslator).t(key, {
    ns: "applicationMetadata",
    keySeparator: false,
    defaultValue: fallback,
    interpolation: { skipOnVariables: true },
  });
}

/** Subscribe rendering while retaining stable callbacks for delayed feedback. */
export function useApplicationMetadataLanguage(): void {
  useTranslation("applicationMetadata");
}
